<template>
  <div>
    <div v-if="data.status==='paymentPending' && data.payment_id!==null">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
      <v-btn class="btn-update"  :loading="loading" @click="action(data,'paymentDialog')"
                     v-bind="attrs"
                     v-on="on">
        <v-icon class="m-1">mdi-credit-card</v-icon>پرداخت</v-btn>
            </template>
            <span>سفارش شما تایید شده است.برای پرداخت و نهایی سازی سفارش روی دکمه پرداخت کلیک کنید.</span>
          </v-tooltip>
    </div>


    <div v-else>
      <span v-bind:class="'badge badge-' +badgeColor">{{badgeText}}</span>
    </div>

  </div>
</template>

<script>

export default {
  created() {
    this.getStatusBadge(this.data.status)
  },
  data() {
    return {
      badgeColor:null,
      badgeText:null,
      loading:false,
      payDialogInfo:null,
      dialogPayment:false,
    }
  },
  methods: {
    getStatusBadge(status) {
      let text = status;
      let color = 'light'

      switch (status) {
        case "pending":
          this.badgeText = 'در انتظار تایید';
          this.badgeColor = 'warning'
          break;

        case "accept":
          this.badgeText = 'در انتظار پرداخت';
          this.badgeColor = 'info'
          break

        case "reject":
          this.badgeText = 'رد شده';
          this.badgeColor = 'danger'
          break

        case "disable":
          this.badgeText = 'مسدود';
          this.badgeColor = 'light'
          break

          case "paid":
          this.badgeText = 'پرداخت شده';
          this.badgeColor = 'success'
          break
      }

      return `<span class="badge badge-${color}">${text}</span>`;
    },
  },
  props: {
    data: {},
    action: {
      type: Function
    }, meta: {
      type: Object
    }
  },


}
</script>
